export const initialPos = {
  x: 250,
  y: 150,
  angle: 0,
};
